/* V10 QA fix — restore Horizon desktop menu state after leaving the mobile breakpoint. */
(() => {
  const mobileViewport = window.matchMedia('(max-width: 749px)');
  const isTouchDevice = () => 'ontouchstart' in window && navigator.maxTouchPoints > 0;

  const syncHeaderModeOnBreakpointChange = (event) => {
    const headerComponent = document.querySelector('#header-component');
    if (!headerComponent) return;

    if (event.matches || isTouchDevice()) {
      if (headerComponent.dataset.menuStyle !== 'drawer') {
        headerComponent.dataset.menuStyle = 'drawer';
      }
      return;
    }

    // On a mouse/trackpad desktop, make the menu measurable again.
    // Horizon's native overflow-list then decides whether it needs to fall back to the drawer.
    if (headerComponent.dataset.menuStyle !== 'menu') {
      headerComponent.dataset.menuStyle = 'menu';
    }
  };

  mobileViewport.addEventListener('change', syncHeaderModeOnBreakpointChange);
})();


/* Keep the draw link visually consistent in every translated menu. */
(() => {
  const labels = new Set(['Tirage au sort', 'Run the draw', 'Sorteo']);

  const decorate = (scope = document) => {
    scope.querySelectorAll?.('#header-component a, #header-component summary').forEach((link) => {
      if (!(link instanceof HTMLElement) || link.dataset.ssDrawLink === 'true') return;
      const label = link.textContent.replace(/\s+/g, ' ').trim();
      if (!labels.has(label)) return;

      link.dataset.ssDrawLink = 'true';
      link.classList.add('ss-draw-link');
      const star = document.createElement('span');
      star.className = 'ss-draw-link__star';
      star.setAttribute('aria-hidden', 'true');
      star.textContent = '✦';
      link.prepend(star);
    });
  };

  const boot = () => {
    decorate();
    new MutationObserver((records) => {
      records.forEach((record) => record.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches?.('#header-component a, #header-component summary')) decorate(node.parentElement || document);
        else decorate(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();